import actionsBase from './actionsBase'
import actionsSave from './actionsSave'
import actionsSet from './actionsSet'

export default {
  ...actionsBase,
  ...actionsSave,
  ...actionsSet
}
